import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { IconButton, LinkIcon, SideBarToModal, Tab, Tabs } from 'reaxl';
import { SaveGlyph } from 'reaxl-molecules';
import { useBrand } from '@atc/brand';
import ShareEmail from './ShareEmail';
import ShareText from './ShareText';
const sideBarOptions = {
  fullWidth: true
};
const modalOptions = {
  scrollPanel: false
};

/**
 *  Share email or text with a share icon that opens a modal with email and text functionality
 *
 */
function ShareContent(_ref) {
  let {
    buttonText = 'Share',
    emailProps = {},
    glyphColor,
    isMobile = false,
    isStaticContent = false,
    onClick = () => {},
    resetEmailFriend = () => {},
    resetTextFriend = () => {},
    textProps = {
      message: '',
      url: '',
      onTabClick: () => {}
    },
    title = 'Share this car',
    uiContext = 'stacked',
    ...rest
  } = _ref;
  const isStacked = uiContext === 'stacked';
  const isInline = uiContext === 'inline';
  const [isOpen, setModalOpen] = useState(false);
  const {
    brand
  } = useBrand();
  const onClickOpen = event => {
    setModalOpen(true);
    onClick(event);
  };
  const onClickClose = () => {
    setModalOpen(false);
    resetEmailFriend();
    resetTextFriend();
  };
  const onTabSelect = key => {
    if (key === 2 && isMobile) {
      window.location.href = `sms:?&body=${textProps.message}`;
      textProps.onTabClick();
      onClickClose();
    }
  };

  // Show non-tabbed Email Form if no text message available
  // Else show tabbed view with email and text
  const content = !textProps.message ? /*#__PURE__*/React.createElement(ShareEmail, emailProps) : /*#__PURE__*/_jsx(Tabs, {
    alignment: "left",
    defaultActiveKey: 1,
    id: "share-content-tabs",
    onSelect: onTabSelect
  }, void 0, /*#__PURE__*/_jsx(Tab, {
    eventKey: 1,
    title: "Email",
    className: "margin-top-5"
  }, void 0, /*#__PURE__*/React.createElement(ShareEmail, emailProps)), /*#__PURE__*/_jsx(Tab, {
    eventKey: 2,
    title: "Text",
    className: "margin-top-5"
  }, void 0, isMobile ? null : /*#__PURE__*/React.createElement(ShareText, textProps)));
  if (isStaticContent) return content;
  let modalTrigger;
  switch (uiContext) {
    case 'link':
      modalTrigger = /*#__PURE__*/_jsx(LinkIcon, {
        onClick: onClickOpen,
        glyph: "share",
        placement: "before",
        glyphClassName: "margin-right-3 text-accent text-size-400"
      }, void 0, buttonText);
      break;
    case 'glyph':
      modalTrigger = /*#__PURE__*/_jsx(SaveGlyph, {
        action: "share",
        brand: brand,
        onClick: onClickOpen,
        uiContext: glyphColor === 'accent' ? 'accent-circle' : 'default',
        className: "text-size-600"
      });
      break;
    case 'stacked':
    case 'inline':
    default:
      modalTrigger = /*#__PURE__*/_jsx(IconButton, {
        glyph: "share",
        monochrome: glyphColor === 'default',
        label: buttonText,
        size: isInline ? 'small' : undefined,
        layout: isStacked ? 'stacked' : undefined,
        onClick: onClickOpen
      });
      break;
  }
  return /*#__PURE__*/React.createElement("div", rest, modalTrigger, /*#__PURE__*/_jsx(SideBarToModal, {
    title: title,
    content: content,
    collapsed: isMobile,
    show: isOpen,
    onHide: onClickClose,
    sideBarOptions: sideBarOptions,
    modalOptions: modalOptions
  }));
}
export default /*#__PURE__*/React.memo(ShareContent);